module.exports = __webpack_public_path__ + "band_12_son.8c3e1c3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_12_son.png
// module id = roop
// module chunks = 0